<template>
	<div class="body">
		<div class="body-container">
			<div class="main-container">
				<div class="left-box">
					<video :width="videoOptions.width" :height="videoOptions.height" controls autoplay
						:poster="videoOptions.poster" :preload="videoOptions.preload" :key="videoOptions.src">
						<source :src="videoOptions.src" type="video/mp4">
					</video>
				</div>
				<div class="right-box">
					<div class="box-title">其它视频</div>
					<div class="other-video" v-for="(item, index) in otherVideoList" :key="index"
						:class="{'active-video': activeVideo == index}" @click="playOtherVideo(index)">
						<img src="../assets/icons/play.png" />
						<div class="video-title">{{ item.name }}</div>
					</div>
				</div>
			</div>

			<div class="video-container">
				<div class="box-title">精彩视频</div>
				<div class="video-box">
					<div class="video-card card-margin-left" v-for="(item, index) in wonderfulVideoList" :key="index" @click="playNiceVideo(index)">
						<img class="card-img" :src="item.images" />
						<div class="card-title">{{ item.name }}</div>
					</div>
				</div>
			</div>

			<div class="video-container">
				<div class="box-title">名师专家</div>
				<div class="video-box">
					<div class="video-card card-margin-left" v-for="(item, index) in expertList" :key="index"
						@click="toExpert(item)">
						<img class="card-img" :src="item.images" />
						<div class="card-title card-title-center">{{ item.name }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getPageData,
		getRmdList
	} from "@/api/voice"
	import TEST_VIDEOS from './video.json'
import { isEmpty } from "../utils/util";


	export default {
		name: "Voice",
		data() {
			return {
				otherVideoList: [],
				wonderfulVideoList: [],
				expertList: [],
				activeVideo: undefined,
				activeNiceIndex: undefined,
				dp: null,
				videoOptions: {
					width: '100%',
					height: '100%',
					poster: undefined, // 视频封面
					preload: "auto", // 预加载
					src: undefined,
				},
			}
		},
		created() {
			this.initPageData();
			this.initPassParams();
		},
		methods: {
			initPageData() {
				getPageData().then(res => {
					this.wonderfulVideoList = res.data.videoList;
					this.expertList = res.data.authorList;
				});
			},
			
			initPassParams() {
				let params = this.$route.query
				console.log('initPassParams params', params)
				if (!isEmpty(params.id)) {
					this.requestRmdData(params.id);
				}else{
					this.requestRmdData(0);
				}
				
				if (!isEmpty(params.videoUrl)){
					let videoUrl = decodeURIComponent(params.videoUrl);
					let imageUrl = decodeURIComponent(params.images)
					
					this.videoOptions.poster = imageUrl;
					this.videoOptions.src = videoUrl;
				}
			},
			
			requestRmdData(id) {
				getRmdList({
					'id': id
				}).then(res => {
					this.otherVideoList = res.data.list;
				});
			},

			playOtherVideo(index) {
				this.activeVideo = index;
				this.videoOptions.poster = this.otherVideoList[this.activeVideo].images;
				this.videoOptions.src = this.otherVideoList[this.activeVideo].url;
			},

			playNiceVideo(index) {
				this.activeNiceIndex = index;
				this.videoOptions.poster = this.wonderfulVideoList[this.activeNiceIndex].images;
				this.videoOptions.src = this.wonderfulVideoList[this.activeNiceIndex].url;
			},

			toExpert(expert) {
				// this.$router.replace('/voice/expert/' + expert.id);
				this.$router.push('/voice/expert/' + expert.id);
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "voice.scss";
</style>